export const DEVICE_ICONS = {
  DELETED: 'deleted',
  BLOCK: 'block',
  ACTUAL: 'actual',
  ONLINE: 'online',
};
